import React from 'react';
import { Routes, Route } from 'react-router';
import { useSelector } from 'react-redux';
import { AppHeader } from './AppHeader';
import { ErrorBoundary } from './ErrorBoundary';
import { UnauthorizedPage } from './UnauthorizedPage';
import { SignedOutPage } from './SignedOutPage';
import { MainPage } from './MainPage';
import './App.css';
import { TopicsOverview } from '../components/TopicsOverview';
import { TopicDetail } from '../components/TopicDetail';
import { getAuthServiceSingleton, getLoginErrorMessage } from '../services/authentication/authService';
import setupAppInsights from '../services/appInsights/appInsightsSetup';
import { getUserIdentity } from '../store/auth/selectors';
import { DIWA_ADMIN_ROLE } from '../constants';

export default function App() {
  const userIdentity = useSelector(getUserIdentity);

  useMountEffect(() => {
    const authService = getAuthServiceSingleton();
    void authService.ensureUserLoggedIn()
      .catch((e) => {
        throw new Error(getLoginErrorMessage(e));
      })
      .then(setupAppInsights);
  });

  const isAdmin = userIdentity?.roles.some((role) => role === DIWA_ADMIN_ROLE);

  return (
    <>
      { isAdmin ? <AppHeader /> : '' }
      <ErrorBoundary>
        <div className="appHeaderSpacing" />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="/signedout" element={<SignedOutPage />} />
          {isAdmin ? (
            <>
              <Route path="/topics" element={<TopicsOverview />} />
              <Route path="/topic" element={<TopicDetail />} />
            </>
          ) : ''}
        </Routes>
      </ErrorBoundary>
    </>
  );
}

// For initial rendering of containers
export const useMountEffect = (eff: React.EffectCallback, dependency?: any) => React.useEffect(eff, [dependency]);
